import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Name', prop: 'name' },
  { title: 'Email Domain', prop: 'email_domains', format: 'array' },
  { title: 'Created', prop: 'created_at', format: 'fromNow' }
]

const filters = [
  { name: 'Filter by name', prop: 'filters.name_ilike', type: 'text', enabled: true },
  { name: 'Start date', prop: 'filters.start_date', type: 'datepicker', enabled: true },
  { name: 'End date', prop: 'filters.end_date', type: 'datepicker', enabled: true },
  { name: 'Show deleted', prop: 'with_deleted', type: 'bool', value: true, enabled: false }
]

const defaults = {
  order: [{ column: 'name', direction: 'asc' }]
}

const Institutions = props => (
  <List
    title='Institutions'
    apiPath='admin/institutions'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    withExport
  />
)

export default Institutions
